<template>
    <div class="modal hide fade in" id="modalExternos" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edición de datos externos en documento enviado</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                         <div class="form-group col-12">
                            <label>Nombre del Receptor:</label>
                            <input type="text" id="nombreReceptor_div" class="form-control" v-model="NombreReceptor" />
                        </div>
                     </div>
                     <div class="row">
                         <div class="form-group col-12">
                            <label>{{AreaExterna.Nombre}}</label>
                            <input type="number" id="numero_div" class="form-control" v-model="Numero" />
                        </div>
                     </div>
                     <div class="row">
                         <div class="form-group col-12">
                            <label>Observaciones:</label>
                            <input type="text" id="Observaciones_div" class="form-control" v-model="Observaciones" />
                        </div>
                     </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" id="botonCancelar" >&nbsp; &nbsp; Cancelar &nbsp; &nbsp;</button>
                    <button type="button" class="btn btn-success" id="botonAceptar" >&nbsp; &nbsp; &nbsp; Aceptar &nbsp; &nbsp; &nbsp;</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'

export default {
    props: {
        movimiento: Object
    },
    data(){
        return {
            AreaExterna :{
                AreaExternaId: 0,
                Nombre: ''
            },
            DetalleExternoId: 0,
            MovimientoDocumentoId: 0,
            NombreReceptor: "",
            Numero: 0,
            Observaciones : "",
            Estatus: false
        }
    },
    methods:{
         Mostrar: function () {
            $('#modalExternos').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.Editar);
            },
        ModalClose: function(peticion){
            $('#modalExternos').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {'Estatus': this.Estatus, "Detalles": peticion});
        },
        Editar(){
            comun.SeEstaCargandoInformacion(true);
            this.Estatus = true;
            var peticion = { 
                "detallesExternos": {
                "DetalleExternoId": this.DetalleExternoId,
                "MovimientoDocumentoId" : this.MovimientoDocumentoId,
                "NombreReceptor": this.NombreReceptor,
                "Numero": this.Numero,
                "Observaciones": this.Observaciones }
            };
            axios.post(api.conexion + api.ArchivoJudicial.EditarExternos, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    this.Estatus = false;
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    this.Estatus = true;
                    this.ModalClose(peticion);
                }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                this.Estatus = false;
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            });
        }
    },
    mounted(){
        this.AreaExterna = this.movimiento.AreaExterna;
        this.DetalleExternoId = this.movimiento.DetallesExternos.DetalleExternoId;
        this.MovimientoDocumentoId = this.movimiento.DetallesExternos.MovimientoDocumentoId;
        this.NombreReceptor = this.movimiento.DetallesExternos.NombreReceptor;
        this.Numero = this.movimiento.DetallesExternos.Numero;
        this.Observaciones = this.movimiento.DetallesExternos.Observaciones;

        this.Mostrar()
    }
}
</script>
<style scoped>
    .modal-content {
      background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/EditExternos.vue